import React from "react";
import RangeSlider from "react-bootstrap-range-slider";
const SearchRolesYears = (props) => {
  const {
    searchBarValue,
    onChangeSearchBar,
    onClickOfRoles,
    category,
    filteredRoles,
    currentYearsValue,
    onClickSlideStop,
    step,
    max,
    min,
  } = props;

  return (
    <div
      className="col-lg-3 col-md-3 col-sm-12 col-xs-12 
                  .white-background float-left"
    >
      <div className="row col-lg-12 col-md-12 col-sm-12 col-xs-12 openings-search-box aligning-center text-color-black">
        <input
          className="searchRolesYears-width"
          type="text"
          value={searchBarValue}
          onChange={(event) => onChangeSearchBar(event)}
          placeholder="Search"
          required
        />
      </div>
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 roles-tile aligning-center searchRolesYears-padding">
        <div>
          <a
            className="btn btn-zzz category-button dropdown-toggle "
            data-toggle="dropdown"
            href="#"
          >
            {category} <span className="caret" />
          </a>
          <ul className="dropdown-menu">
            {filteredRoles.map((button, index) => {
              return (
                <li
                  key={index}
                  className="text-center text-uppercase"
                  onClick={() => onClickOfRoles(button)}
                >
                  <a>{button}</a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
      <div className="row container col-lg-12 col-md-12 col-sm-12 col-xs-12 searchRolesYears-padding years-exp-margin center-block aligning-center openings-search-box">
        <div className="years-exp-box text-color-black">
          Years of experience
        </div>
        <div className="searchRolesYears-padding">
          <RangeSlider
            value={currentYearsValue}
            onChange={(e) => onClickSlideStop(e)}
            tooltipLabel={(currentYearsValue) => `${currentYearsValue}`}
            tooltipPlacement="bottom"
            tooltip="on"
            step={step}
            max={max}
            min={min}
            variant="success"
          />
        </div>
      </div>
    </div>
  );
};
export default SearchRolesYears;



// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/careers/SearchRolesYears/SearchRolesYears.js